var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"mx-1 my-1",attrs:{"variant":_vm.badgeColor}},[_vm._v(" "+_vm._s(_vm.label)+" "+_vm._s(_vm.value ? '(' + _vm.formattedDate + ')' : '')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }